export const colors = {
  background: "#f2f2f2",
  backgroundSoft: "#d7f3ec",
  accentTint: "#e8fbf6",
  card: "#ffffff",
  cardStrong: "#f4fcf9",
  cardTint: "#f7fbff",
  border: "rgba(28,27,46,0.08)",
  borderLight: "rgba(28,27,46,0.15)",
  borderDark: "rgba(0,0,0,0.08)",
  text: "#1c1b2e",
  textMuted: "#525270",
  textDim: "#5d5d78",
  aqua: "#ff2d7e",
  lime: "#20bf6b",
  coral: "#fa8231",
  amber: "#fecb32",
  purple: "#9c4dff",
  pink: "#38b6ff",
  glowAqua: "rgba(255,45,126,0.06)",
  glowPurple: "rgba(156,77,255,0.05)",
  glowPink: "rgba(56,182,255,0.05)",
  white: "#ffffff",
  transparent: "transparent",
  green: "#00e676",
  cyan: "#00bcd4",
  gold: "#fbbf24",
  silver: "#94a3b8",
  rose: "#fb7185",
  badgeBlue: "#7c5cfc",
  badgeBlueFaded: "#7c5cfc80",
  mutedBlue: "#6b6b85",
  goldBg: "#fffcf2",
  silverBg: "#f8f9fa",
  roseBg: "#fff5f5",
  amberBg: "#fffbf2",
  surfaceBorder: "rgba(28,27,46,0.2)",
  rankBg: "rgba(28,27,46,0.05)",
  divider: "rgba(28,27,46,0.1)",
  overlayLight: "rgba(0,0,0,0.04)",
  overlayDark: "rgba(0,0,0,0.5)",
  greenGlow4: "rgba(0,230,118,0.04)",
  greenGlow6: "rgba(0,230,118,0.06)",
  greenGlow8: "rgba(0,230,118,0.08)",
  greenGlow18: "rgba(0,230,118,0.18)",
  purpleGlow7: "rgba(156,77,255,0.07)",
  purpleGlow10: "rgba(156,77,255,0.1)",
  pinkGlow7: "rgba(56,182,255,0.07)",
  limeGlow8: "rgba(32,191,107,0.08)",
  redGlow8: "rgba(255,59,48,0.08)",
  amberGlow10: "rgba(254,203,50,0.1)",
  amberGlow20: "rgba(254,203,50,0.2)",
  pastMuted: "#8b8ba8",
  pastFaded: "#a4a4c1",
  pastLight: "#c0c0d8",
} as const;

export const radii = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
  xxxl: 32,
  full: 9999,
} as const;

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
  xxxl: 32,
} as const;

export const shadows = {
  card: {
    shadowColor: colors.text,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0,
    shadowRadius: 0,
    elevation: 0,
  },
} as const;

export const typography = {
  xs: { fontSize: 10, lineHeight: 14 },
  sm: { fontSize: 12, lineHeight: 16 },
  base: { fontSize: 14, lineHeight: 20 },
  lg: { fontSize: 15, lineHeight: 20 },
  xl: { fontSize: 16, lineHeight: 22 },
  "2xl": { fontSize: 17, lineHeight: 22 },
  "3xl": { fontSize: 18, lineHeight: 24 },
  "4xl": { fontSize: 20, lineHeight: 26 },
  "5xl": { fontSize: 22, lineHeight: 28 },
  "6xl": { fontSize: 24, lineHeight: 30 },
  "7xl": { fontSize: 28, lineHeight: 34 },
  "8xl": { fontSize: 32, lineHeight: 38 },
  "9xl": { fontSize: 36, lineHeight: 42 },
} as const;

export const RANK_COLORS = [colors.gold, colors.silver, colors.rose] as const;

export const TOP3_BG_COLORS = [colors.goldBg, colors.silverBg, colors.roseBg] as const;

export const LANE_COLORS = [
  colors.aqua,
  colors.cyan,
  colors.lime,
  colors.gold,
  colors.purple,
  colors.coral,
] as const;

export const ACCENT_COLORS = [colors.aqua, colors.purple, colors.pink] as const;

export const PAST_ACCENT_COLORS = [colors.pastMuted, colors.pastFaded, colors.pastLight] as const;
